import { Head, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import PtoRequestForm from "./_form"

interface Props {
  pto_request: {
    id: number
    request_type: number
    start_date: string | null
    end_date: string | null
    start_time: string
    start_period: string
    end_time: string
    end_period: string
    hours_requested: number
    full_day: boolean
    reason: string
  }
  request_types: { value: number; label: string }[]
  errors?: Record<string, string[]>
}

export default function Edit({ pto_request, request_types, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "PTO Requests", href: "/pto_requests" },
    { title: "Edit Request", href: `/pto_requests/${pto_request.id}/edit` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Edit PTO Request" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Edit PTO Request</h1>

        <div className="rounded-lg bg-white p-6 shadow">
          <PtoRequestForm
            ptoRequest={pto_request}
            requestTypes={request_types}
            errors={errors}
            onCancel={() => router.get("/pto_requests")}
          />
        </div>
      </div>
    </AppLayout>
  )
}
